import constants from '../config/constants';

/** @type {import('@nuxt/types').Plugin} */
const axiosExtend = ({ $axios, app }) => {
    $axios.onRequest(() => {
        const csrf = app.$cookies.get(constants.CSRF_COOKIE_NAME);
        if (csrf) {
            $axios.setHeader('x-csrf-token', csrf);
        }
    });
};

export default axiosExtend;
